import type { BillingAPIInterface } from './api-switcher'
import { client } from './client'
import { responseDataConverter } from './converters'

export const BillingAPI: BillingAPIInterface = {
  createCheckoutSession: (product_id, price_id, success_url, cancel_url, plan_id, signal) => {
    console.log('createCheckoutSession called with:', { product_id, price_id, success_url, cancel_url, plan_id })
    return responseDataConverter(
      client.POST('/billing/checkout-session', {
        body: {
          product_id,
          price_id,
          plan_id,
          success_url,
          cancel_url
        },
        signal
      }),
      (data) => data.checkout_url
    )
  },

  getMySubscription: (signal) =>
    client.GET('/me/subscription', { signal }),

  updateMySubscription: (price_id, product_id, preview_token, signal) =>
    client.PUT('/me/subscription', {
      body: { price_id, product_id, preview_token },
      signal
    }),

  previewMySubscriptionUpdate: (price_id, product_id, signal) =>
    client.POST('/me/subscription/preview', {
      body: { price_id, product_id },
      signal
    }),

  resumeMySubscription: (signal) =>
    client.POST('/me/subscription/resume', { signal })
}